import { Button } from "components/atoms/button/button";
import styled from "styled-components";
import { breakpoints } from "styles";

export const NpsFeedbackExplanationFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
`;

export const CocoSadImageContainer = styled.div`
  width: 144px;
  height: 144px;
`;

export const NpsFeedbackExplanationFormHeading = styled.h1`
  width: 330px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  text-align: center;
  margin-top: 30px;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  line-height: 40px;

  @media ${breakpoints.laptop} {
    width: 425px;
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  }
`;

export const NpsFeedbackExplanationFormSubheading = styled.h3`
  width: 300px;
  text-align: center;
  font-weight: normal;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  margin: 12px 0 24px 0;
  color: ${({ theme }) => theme.colors.neutral["900"]};

  @media ${breakpoints.laptop} {
    width: 425px;
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }
`;

export const StyledButtonContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;

  @media ${breakpoints.laptop} {
    width: 260px;
    margin-bottom: 24px;
  }
`;

export const SkipCTA = styled(Button)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  background: none;
  border: none;
  font-weight: bold;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  cursor: pointer;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    margin-top: 0;
  }
`;
export const TextAreaWrapper = styled.div`
  width: 310px;
  height: 100px;
  margin-bottom: 45px;
  @media ${breakpoints.laptop} {
    width: 425px;
  }
`;
